import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { groupBy } from 'dpl/shared/utils';

import { SECTIONS } from '../utils/constants';
import MagazineFrontPageMainArticle from './MagazineFrontPageMainArticle';
import MagazineFrontPageSecondaryArticle from './MagazineFrontPageSecondaryArticle';
import MagazineFrontPageArticleSection from './MagazineFrontPageArticleSection';

export default function MagazineFrontPage({ sliceData }) {
  const secondaryArticles = [
    sliceData.primary.secondary_article,
    sliceData.primary.tertiary_article
  ];

  const groupedArticles = groupBy(
    sliceData.items.filter(i => i.article.data),
    'section'
  );
  const articleSections = [
    [sliceData.primary.section_1_headline, groupedArticles[SECTIONS.SECTION_1]],
    [sliceData.primary.section_2_headline, groupedArticles[SECTIONS.SECTION_2]]
  ].filter(([title, articles]) => title && articles && articles.length > 0);

  return (
    <div className="PrismicMagazineFrontPage container">
      <div className="row">
        <div className="mb4 mb0-lg col-lg-6">
          <MagazineFrontPageMainArticle
            article={sliceData.primary.main_article}
          />
        </div>
        <div className="mb12 mb0-lg col-lg-3">
          {secondaryArticles.map((article, idx) => (
            <div
              className={classnames('pt4 pt0-lg bt bn-l b--light-gray', {
                mb6: idx !== secondaryArticles.length - 1
              })}
              key={idx}
            >
              <MagazineFrontPageSecondaryArticle article={article} />
            </div>
          ))}
        </div>
        <div className="pb12 pb0-lg col-lg-3">
          <div className="row">
            {articleSections.map(([title, articles], idx) => (
              <div key={idx} className="col-12 col-md-6 col-lg-12">
                <div
                  className={classnames({
                    'mb12 mb10-lg': idx !== articleSections.length - 1
                  })}
                >
                  <MagazineFrontPageArticleSection
                    articles={articles.map(article => article.article)}
                    title={title}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

MagazineFrontPage.propTypes = {
  sliceData: PropTypes.shape({
    primary: PropTypes.shape({
      // eslint-disable-next-line react/forbid-prop-types
      main_article: PropTypes.object,
      // eslint-disable-next-line react/forbid-prop-types
      secondary_article: PropTypes.object,
      // eslint-disable-next-line react/forbid-prop-types
      tertiary_article: PropTypes.object,
      section_1_headline: PropTypes.string,
      section_2_headline: PropTypes.string
    }).isRequired,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        section: PropTypes.oneOf(Object.values(SECTIONS)),
        // eslint-disable-next-line react/forbid-prop-types
        article: PropTypes.object
      })
    )
  }).isRequired
};
